import { adjustColor, hexToRgba } from '../utils/colorUtils';

function buildCss(c, cL, cD, ca10, ca20) {
  return `
@keyframes slp-shift {
  0%, 100% { background-position: 0% 50%; }
  50%       { background-position: 100% 50%; }
}

.slp { font-family: system-ui, -apple-system, sans-serif; background: #fff; width: 100%; }

.slp-header {
  background: linear-gradient(135deg, ${c}, ${cL});
  padding: 20px 64px; display: flex; justify-content: space-between; align-items: center;
}
.slp-logo { color: #fff; font-size: 24px; font-weight: 800; letter-spacing: -0.02em; }
.slp-header-btn {
  padding: 10px 32px; background: #fff; color: ${c}; border: none;
  border-radius: 6px; font-weight: 700; font-size: 15px; cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.slp-header-btn:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0,0,0,0.12); }

.slp-hero {
  background: linear-gradient(135deg, ${c}, ${cL}, ${cD}, ${c});
  background-size: 300% 300%;
  animation: slp-shift 8s ease infinite;
  padding: 80px 64px; display: flex; gap: 64px; align-items: center;
}
.slp-hero-text { flex: 1; min-width: 0; }
.slp-hero--no-img { justify-content: center; }
.slp-hero--no-img .slp-hero-text { flex: none; max-width: 680px; text-align: center; }
.slp-hero-badge {
  display: inline-block; padding: 6px 18px;
  background: rgba(255,255,255,0.2); color: #fff;
  border: 1px solid rgba(255,255,255,0.3); border-radius: 20px;
  font-size: 14px; font-weight: 600; margin-bottom: 28px;
}
.slp-hero-h1 {
  font-size: 48px; color: #fff; line-height: 1.25;
  margin-bottom: 28px; font-weight: 800; letter-spacing: -0.03em;
}
.slp-hero-desc { font-size: 17px; color: rgba(255,255,255,0.85); margin-bottom: 48px; line-height: 1.85; }
.slp-hero-btn {
  padding: 18px 64px; background: #fff; color: ${c}; border: none;
  border-radius: 10px; font-size: 17px; font-weight: 800; cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.slp-hero-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(0,0,0,0.2); }
.slp-hero-img-wrap { position: relative; flex: 1; height: 360px; overflow: hidden; border-radius: 14px; flex-shrink: 0; min-width: 0; background-color: #f5f5f5; }
.slp-hero-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; object-position: center; display: block; }

.slp-features { padding: 96px 64px; background: ${ca10}; }
.slp-section-label { text-align: center; color: ${c}; font-size: 13px; letter-spacing: 0.2em; font-weight: 600; margin-bottom: 14px; }
.slp-section-h2 { text-align: center; font-size: 34px; color: #111; font-weight: 800; margin-bottom: 56px; }
.slp-features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 28px; }
.slp-feature-card {
  background: #fff; border-radius: 14px; padding: 36px;
  box-shadow: 0 4px 24px ${ca10};
  transition: transform 0.25s, box-shadow 0.25s;
}
.slp-feature-card:hover { transform: translateY(-6px); box-shadow: 0 16px 48px ${ca20}; }
.slp-feature-icon {
  width: 52px; height: 52px; border-radius: 14px;
  background: linear-gradient(135deg, ${c}, ${cL});
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 26px; margin-bottom: 22px;
}
.slp-feature-title { color: #111; font-size: 20px; font-weight: 700; margin-bottom: 14px; }
.slp-feature-desc { color: #666; line-height: 1.85; font-size: 15px; }

.slp-pricing { padding: 96px 64px; text-align: center; }
.slp-pricing-h2 { font-size: 34px; color: #111; font-weight: 800; margin-bottom: 14px; }
.slp-pricing-sub { color: #888; font-size: 16px; margin-bottom: 64px; }
.slp-plans-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; max-width: 880px; margin: 0 auto; align-items: center; }
.slp-plan-card {
  border: 2px solid #e5e7eb; border-radius: 14px; padding: 36px;
  position: relative; background: #fff; transition: transform 0.2s;
}
.slp-plan-card:not(.slp-plan-featured):hover { transform: translateY(-4px); }
.slp-plan-featured {
  border-color: ${c}; background: ${ca10};
  transform: scale(1.05);
  box-shadow: 0 8px 40px ${ca20};
}
.slp-plan-featured:hover { transform: scale(1.07); }
.slp-badge {
  position: absolute; top: -15px; left: 50%; transform: translateX(-50%);
  background: linear-gradient(135deg, ${c}, ${cL});
  color: #fff; padding: 4px 18px; border-radius: 20px; font-size: 12px; font-weight: 700; white-space: nowrap;
}
.slp-plan-name { color: #111; font-size: 24px; font-weight: 700; margin-bottom: 10px; }
.slp-plan-price { color: ${c}; font-size: 34px; font-weight: 800; margin-bottom: 28px; }
.slp-plan-btn {
  width: 100%; padding: 13px 0; background: #fff; color: ${c};
  border: 2px solid ${c}; border-radius: 8px; font-size: 15px; font-weight: 700;
  cursor: pointer; transition: background 0.2s, color 0.2s;
}
.slp-plan-btn:hover { background: ${c}; color: #fff; }
.slp-plan-btn-featured { background: linear-gradient(135deg, ${c}, ${cL}); color: #fff; border-color: transparent; }
.slp-plan-btn-featured:hover { opacity: 0.9; }

.slp-gallery { padding: 88px 64px; background: ${ca10}; }
.slp-gallery-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 40px; }
.slp-gallery-item { position: relative; overflow: hidden; border-radius: 10px; height: 200px; background-color: #f5f5f5; }
.slp-gallery-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; object-position: center; display: block; transition: transform 0.4s; }
.slp-gallery-item:hover .slp-gallery-img { transform: scale(1.05); }

.slp-cta {
  background: linear-gradient(135deg, ${c}, ${cL});
  padding: 100px 64px; text-align: center;
}
.slp-cta-h2 { color: #fff; font-size: 42px; font-weight: 800; margin-bottom: 18px; letter-spacing: -0.02em; }
.slp-cta-sub { color: rgba(255,255,255,0.8); font-size: 18px; margin-bottom: 52px; }
.slp-cta-btn {
  padding: 18px 76px; background: #fff; color: ${c}; border: none;
  border-radius: 10px; font-size: 18px; font-weight: 800; cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.slp-cta-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(0,0,0,0.25); }

.slp-footer { background: #1a0a2e; padding: 36px 64px; text-align: center; color: #555; font-size: 13px; }

@media (max-width: 768px) {
  .slp-header { padding: 14px 20px; }
  .slp-hero { flex-direction: column; padding: 56px 20px; gap: 32px; }
  .slp-hero-h1 { font-size: 28px; }
  .slp-hero-img-wrap { width: 100%; flex: none; height: 220px; }
  .slp-hero-img { height: 100%; }
  .slp-features { padding: 56px 20px; }
  .slp-features-grid { grid-template-columns: 1fr; gap: 20px; }
  .slp-pricing { padding: 56px 20px; }
  .slp-plans-grid { grid-template-columns: 1fr; max-width: 400px; }
  .slp-plan-featured { transform: scale(1); }
  .slp-gallery { padding: 56px 20px; }
  .slp-gallery-grid { grid-template-columns: 1fr; }
  .slp-cta { padding: 64px 20px; }
  .slp-cta-h2 { font-size: 28px; }
  .slp-footer { padding: 24px 20px; }
}
`;
}

export default function ServiceLP({ data }) {
  const c    = data.color || '#7c3aed';
  const cL   = adjustColor(c, 20);
  const cD   = adjustColor(c, -12);
  const ca10 = hexToRgba(c, 0.08);
  const ca20 = hexToRgba(c, 0.18);

  return (
    <>
      <style>{buildCss(c, cL, cD, ca10, ca20)}</style>
      <div className="slp">
        <div className="slp-header">
          <span className="slp-logo">{data.siteName}</span>
          <button className="slp-header-btn">{data.cta}</button>
        </div>

        <div className={`slp-hero${data.heroImage ? '' : ' slp-hero--no-img'}`}>
          <div className="slp-hero-text">
            <div className="slp-hero-badge">こんなお悩みありませんか？</div>
            <h1 className="slp-hero-h1">{data.heroHeading}</h1>
            <p className="slp-hero-desc">{data.description}</p>
            <button className="slp-hero-btn">{data.cta} →</button>
          </div>
          {data.heroImage && (
            <div className="slp-hero-img-wrap">
              <img src={data.heroImage} alt="" className="slp-hero-img" />
            </div>
          )}
        </div>

        <div className="slp-features">
          <p className="slp-section-label">FEATURES</p>
          <h2 className="slp-section-h2">このような課題を解決します</h2>
          <div className="slp-features-grid">
            {data.features.map((f, i) => (
              <div key={i} className="slp-feature-card">
                <div className="slp-feature-icon">✓</div>
                <h3 className="slp-feature-title">{f.title}</h3>
                <p className="slp-feature-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="slp-pricing">
          <p className="slp-section-label">PRICING</p>
          <h2 className="slp-pricing-h2">料金プラン</h2>
          <p className="slp-pricing-sub">シンプルで明確な料金体系</p>
          <div className="slp-plans-grid">
            {data.plans.map((p, i) => (
              <div key={i} className={`slp-plan-card${i === 1 ? ' slp-plan-featured' : ''}`}>
                {i === 1 && <div className="slp-badge">おすすめ</div>}
                <h3 className="slp-plan-name">{p.name}</h3>
                <div className="slp-plan-price">{p.price}</div>
                <button className={`slp-plan-btn${i === 1 ? ' slp-plan-btn-featured' : ''}`}>
                  このプランを選ぶ
                </button>
              </div>
            ))}
          </div>
        </div>

        {data.images && data.images.length > 0 && (
          <div className="slp-gallery">
            <p className="slp-section-label">GALLERY</p>
            <h2 className="slp-section-h2" style={{ marginBottom: 0 }}>導入事例・実績</h2>
            <div className="slp-gallery-grid">
              {data.images.slice(0, 3).map((img, i) => (
                <div key={i} className="slp-gallery-item">
                  <img src={img} alt="" className="slp-gallery-img" />
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="slp-cta">
          <h2 className="slp-cta-h2">今すぐ始めましょう</h2>
          <p className="slp-cta-sub">{data.tagline}</p>
          <button className="slp-cta-btn">{data.cta}</button>
        </div>

        <footer className="slp-footer">© 2025 {data.siteName}. All rights reserved.</footer>
      </div>
    </>
  );
}
